import { CallbackRequestStatus, ICallbackResponse } from "../global/types";
import { XMLHttpConfig } from "../global/XMLHttpConfig";
import { HttpService } from "../services/HttpService";

declare var _gaq: any;

export class CallbackForm {
    private httpSvc: HttpService;

    constructor() {
        this.httpSvc = new HttpService();
        this.BindInteractions();
    }

    private BindInteractions() {
        const form: HTMLFormElement = document.querySelector("[data-callback-form]") as HTMLFormElement;

        if (form) {
            form.addEventListener("submit", (e) => {
                e.preventDefault();

                if (this.ValidateForm()) {
                    this.SendData();
                    _gaq.push(["_trackEvent", "Interaction", "Submit Request Feedback Form (VALIDATED)", document.URL, 0, false]);
                } else {
                    _gaq.push(["_trackEvent", "Interaction", "Submit Request Feedback Form (NOT VALIDATED)", document.URL, 0, false]);
                    this.ShowMessage("Please fill in all the fields provided.");
                }
            });
        }
    }

    private ValidateForm(): boolean {
        const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll("[data-callback-form] [required]") as NodeListOf<HTMLInputElement>;
        let valid: boolean = true;

        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value.length < 3) {
                valid = false;
            }
        } 

        return valid;
    }

    private async SendData() {
        const nameInput: HTMLInputElement = document.querySelector(`[data-callback-form] [name="name"]`) as HTMLInputElement;
        const phoneInput: HTMLInputElement = document.querySelector(`[data-callback-form] [name="telephone"]`) as HTMLInputElement;
        const emailInput: HTMLInputElement = document.querySelector(`[data-callback-form] [name="email"]`) as HTMLInputElement;
        const calltimeInput: HTMLInputElement = document.querySelector(`[data-callback-form] [name="preferredtime"]`) as HTMLInputElement;
        const destinationInput: HTMLInputElement = document.querySelector(`[data-callback-form] [name="destination"]`) as HTMLInputElement;
        const url: string = "/utility/callbackrequest2018.aspx";

        const data: any = {
            name: nameInput.value,
            phone: phoneInput.value,
            email: emailInput.value,
            calltime: calltimeInput.value,
            destination: destinationInput.value,
        };

        const header: any = {
            "Content-type": "application/x-www-form-urlencoded",
        };

        this.SetForm(false);
        const response: ICallbackResponse = await this.httpSvc.post(new XMLHttpConfig(url, data, header));
        this.SetForm(true);

        if (response.Status === CallbackRequestStatus.SUCCESS) {
            this.ShowMessage(response.Message);
            this.CleanUpFormFields();
        } else {
            this.ShowMessage(response.Message);
        }

    }

    private ShowMessage(message: string) {
        const messageContainer: HTMLElement = document.querySelector("[data-callback-response]") as HTMLElement;
        messageContainer.innerText = message;        
    }

    private SetForm(enable: boolean) {
        const messageContainer: HTMLElement = document.querySelector("[data-callback-response]") as HTMLElement;
        const form: HTMLElement = document.querySelector("[data-callback-form]") as HTMLElement;
        const loader: HTMLElement = document.querySelector("[data-callback-loading]") as HTMLElement;

        form.style.display = enable ? "block" : "none";
        loader.style.display = enable ? "none" : "inline-block";

        if (!enable) {
            messageContainer.innerText = "";
        }
    }

    private CleanUpFormFields() {
        const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll("[data-callback-form] [required]") as NodeListOf<HTMLInputElement>;

        for (let i = 0; i < inputs.length; i++) {
            inputs[i].value = "";
        } 
    }

}



// WEBPACK FOOTER //
// ./src/global/CallbackForm.ts